import * as React from 'react'

export const CheckoutIcon = React.memo<JSX.IntrinsicElements['svg']>(
  (props) => {
    return (
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 10.6667C8 9.19391 9.19391 8 10.6667 8H42.6667C44.1394 8 45.3333 9.19391 45.3333 10.6667V42.6667C45.3333 44.1394 44.1394 45.3333 42.6667 45.3333H10.6667C9.19391 45.3333 8 44.1394 8 42.6667V10.6667Z"
          fill="#5BBBFC"
        />
        <path
          d="M18.6667 21.3333C18.6667 19.8606 19.8606 18.6667 21.3333 18.6667H53.3333C54.8061 18.6667 56 19.8606 56 21.3333V53.3333C56 54.8061 54.8061 56 53.3333 56H21.3333C19.8606 56 18.6667 54.8061 18.6667 53.3333V21.3333Z"
          fill="#FFD140"
        />
        <path
          d="M45.3333 18.6667V42.6667C45.3333 44.1394 44.1394 45.3333 42.6667 45.3333H18.6667V21.3333C18.6667 19.8606 19.8606 18.6667 21.3333 18.6667H45.3333Z"
          fill="#FAF8F5"
        />
        <path
          d="M48.4497 48.8335H40.6667C40.2985 48.8335 40 49.132 40 49.5002V50.5002C40 50.8684 40.2985 51.1668 40.6667 51.1668H48.5167L47.6464 52.0371C47.386 52.2975 47.386 52.7196 47.6464 52.9799L48.3535 53.687C48.6138 53.9474 49.0359 53.9474 49.2963 53.687L52.4783 50.5051C52.7386 50.2447 52.7386 49.8226 52.4783 49.5623L49.2963 46.3803C49.0359 46.1199 48.6138 46.1199 48.3535 46.3803L47.6464 47.0874C47.386 47.3477 47.386 47.7698 47.6464 48.0302L48.4497 48.8335Z"
          fill="#E85E00"
        />
        <path
          d="M30.2742 25.512C30.1686 25.602 30.0987 25.7269 30.077 25.864L28.0605 38.624H24.5093C24.4338 38.6243 24.3593 38.6076 24.291 38.5754C24.2228 38.5431 24.1626 38.4961 24.1148 38.4376C24.067 38.3791 24.0328 38.3107 24.0148 38.2374C23.9967 38.164 23.9952 38.0875 24.0104 38.0135L26.5595 21.8678C26.5809 21.7241 26.6515 21.5923 26.7591 21.4949C26.8668 21.3974 27.0048 21.3404 27.1498 21.3334H33.2751C35.9229 21.32 38.2046 23.2195 38.1957 25.7883C37.5145 25.4364 36.6371 25.373 35.716 25.373H30.6527C30.514 25.3727 30.3797 25.422 30.2742 25.512Z"
          fill="#001C64"
        />
        <path
          d="M30.2611 31.8431L31.0256 26.9983C31.0678 26.7416 31.211 26.4849 31.5445 26.4849H35.8176C36.6301 26.4922 37.4863 26.5656 38.1204 26.8972C38.1168 27.1198 38.1005 27.3419 38.0716 27.5627C37.8866 28.7547 37.282 29.8413 36.3669 30.6262C35.4518 31.4112 34.2866 31.8428 33.0816 31.8431H30.2611Z"
          fill="#001C64"
        />
        <path
          d="M39.1561 27.4819C39.1499 27.6924 39.1316 27.9024 39.1012 28.1108C38.6644 30.899 36.2404 32.9565 33.4234 32.9565H30.629C30.478 32.9565 30.332 33.0105 30.2173 33.1087C30.1026 33.2069 30.0266 33.3428 30.003 33.4921L28.6436 42.0715C28.6321 42.145 28.6366 42.2202 28.6568 42.2918C28.6771 42.3634 28.7126 42.4297 28.7609 42.4863C28.8093 42.5429 28.8693 42.5883 28.9368 42.6194C29.0043 42.6505 29.0778 42.6666 29.1521 42.6666H32.1457C32.2946 42.6666 32.4387 42.6141 32.5528 42.5183C32.6669 42.4226 32.7437 42.2897 32.7698 42.1429L33.5105 37.4905C33.5322 37.3533 33.6021 37.2284 33.7076 37.1382C33.8132 37.0481 33.9474 36.9986 34.0862 36.9987H35.8666C38.6836 36.9987 41.1076 34.9409 41.5444 32.1531C41.8537 30.174 40.8586 28.3732 39.1561 27.4819Z"
          fill="#001C64"
        />
      </svg>
    )
  },
)

CheckoutIcon.displayName = 'CheckoutIcon'
